module.exports = "<div class=\"over \">\r\n  <div class=\"panel2TitleWrapper\">\r\n    <div class=\"titlePanel2\">{{Title}}</div>\r\n  </div>\r\n<p class=\"cos\">dsdssfsf</p><p class=\"cos\">dsdssfsf</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allPanels/panels/panel2/panel2.component.html
// module id = ./src/app/allPanels/panels/panel2/panel2.component.html
// module chunks = main